import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { VueAxios } from './axios'
import notification from 'ant-design-vue/es/notification'
import { ACCESS_TOKEN } from '@/store/mutation-types'

// 创建 axios 实例
const service = axios.create({
  baseURL: '', // api base_url
  timeout: 6000 // 请求超时时间
})

const err = (error) => {
  if (error.response) {
    const data = error.response.data
    const token = Vue.ls.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data.message
      })
    }
    if (error.response.status === 401) {
      store.dispatch('Logout')
    }
  }
  // return Promise.reject(error)
}

// request interceptor

var fetching = false
service.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers['Access-Token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  //console.log("config-display",config);

  if(config.url.indexOf("fastdfs")!=-1){ // 如果 URL 中包含字符串 "fastdfs"
    config.baseURL = '/'
  }else if(config.url.indexOf("ndpi")!=-1){
    config.baseURL = '/'
  }else{
    config.baseURL = '/api'
  }

  // if (/^(\/)*fastdfs\/upload/.test(config.url)) {
  //   config.baseURL = '/fastdfs/upload'
  //   config.url = ''
  // }
  return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {
  return response.data
}, err)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}
